module.exports = __webpack_public_path__ + "static/media/white.5a8a7dbc.png";